import { useCallback } from "react";

import { updateUserMeta } from "@actions/main";

import type { PageSizeStorage } from "./useTableV2";
import { useAppDispatch, useAppSelector } from "~/src/store";

export const useUserMetaPageSize = (id: string): PageSizeStorage => {
  const dispatch = useAppDispatch();
  const saved = useAppSelector(
    (state) =>
      (state?.main?.user?.metadata as Record<string, unknown> | undefined)?.[
        id
      ],
  );

  const onPageSizeChange = useCallback(
    (pageSize: number) => {
      dispatch(updateUserMeta(id, pageSize));
    },
    [dispatch, id],
  );

  return {
    pageSize: typeof saved === "number" ? saved : undefined,
    onPageSizeChange,
  };
};
